module.exports = __webpack_public_path__ + "media/images/pc/page_common/logo/logo_footer_an-3f1559f616a28f7ba9764ed22a5b6893.svg";